import qahoy from "views_shared/app/javascript/scripts/qahoy";
import qapi from "views_shared/app/javascript/api";

const useCompanyUpdateApi = ({
  setIsUpdating,
  setGeneralError,
  setAsyncError,
  company,
  setOpenEditModal,
  setDoTopLevelFetch,
}) => {
  const updateCompany = async (data, options = {}) => {
    const { closeModal = true } = options;

    const cleanData = () => {
      const newData = {};
      Object.keys(data).forEach((key) => {
        if (data[key]?.length === 0) {
          newData[key] = null;
        } else {
          newData[key] = data[key];
        }
      });

      return newData;
    };

    try {
      setIsUpdating(true);
      setGeneralError(null);

      qahoy.track("Companies#updateCompany");

      const response = await qapi.companies.updateById(company.id, cleanData());

      if (response.data) {
        if (closeModal) setOpenEditModal(null);
        setDoTopLevelFetch(true);
      } else {
        setGeneralError(response);
      }
    } catch (error) {
      setAsyncError(error);
    } finally {
      setIsUpdating(false);
    }
  };

  return { updateCompany };
};

export default useCompanyUpdateApi;
